import { render, staticRenderFns } from "./TournamentForm.vue?vue&type=template&id=62aca0a2&scoped=true&"
import script from "./TournamentForm.vue?vue&type=script&lang=js&"
export * from "./TournamentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aca0a2",
  null
  
)

export default component.exports